import React, { useContext } from 'react';
import { Button, Header } from 'semantic-ui-react';
import { DomainContext } from '../../DaySmartPublishModal.context';
import './CheckoutConfirmation.css';
var defaultProps = {
  onBack: function onBack() {
    return null;
  }
};
export default function CheckoutConfirmation(_ref) {
  var onBack = _ref.onBack;

  var _useContext = useContext(DomainContext),
      domain = _useContext.domain;

  return /*#__PURE__*/React.createElement("div", {
    className: "day-smart-checkout-confirmation-container"
  }, /*#__PURE__*/React.createElement(Header, {
    as: "h2"
  }, "Domain Selection Complete"), /*#__PURE__*/React.createElement("p", null, "Thanks for selecting your domain, ", /*#__PURE__*/React.createElement("strong", null, domain), ". We have sent an email to you and your DaySmart rep to notify them you have selected a domain. Once you complete the website purchase with them, we will purchase and connect the domain to your new website!"), /*#__PURE__*/React.createElement(Button, {
    onClick: onBack
  }, "Change Domain"));
}
CheckoutConfirmation.defaultProps = defaultProps;